import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { FLINT } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
const StyledPillButton = styled(UIButton).withConfig({
  displayName: "FindPartnerWizardPillButton__StyledPillButton",
  componentId: "sc-1xsog43-0"
})(["&&{border-style:solid;border-width:1px;border-radius:14px;border-color:", ";white-space:nowrap;}"], FLINT);
export default function PillButton(_ref) {
  let {
    children,
    onClick,
    tooltipTitle
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "onClick", "tooltipTitle"]);

  return /*#__PURE__*/_jsx(StyledPillButton, Object.assign({
    use: "unstyled",
    className: "p-x-2 m-left-0 m-y-1 m-right-2",
    onClick: onClick
  }, rest, {
    children: tooltipTitle ? /*#__PURE__*/_jsx(UITooltip, {
      placement: "bottom",
      title: tooltipTitle,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "row",
        children: [children, /*#__PURE__*/_jsx(UIIcon, {
          className: "m-left-1",
          name: "add",
          size: "xxs"
        })]
      })
    }) : /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "row",
      children: [children, /*#__PURE__*/_jsx(UIIcon, {
        className: "m-left-1",
        name: "add",
        size: "xxs"
      })]
    })
  }));
}